import { render, staticRenderFns } from "./TerminalElecInvoice.vue?vue&type=template&id=6bef1295&"
import script from "./TerminalElecInvoice.vue?vue&type=script&lang=js&"
export * from "./TerminalElecInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports